// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Cards__Wrapper_2WhYM","Title":"Cards__Title_23Z3v","Lead":"Cards__Lead_1iqWQ","Cards":"Cards__Cards_mL8Tn grid","Tabs":"Cards__Tabs_2NK9Q"};